module.exports = __webpack_public_path__ + "static/media/heart-icon.bd929cbb.svg";